import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Grid, Typography, Box } from "@mui/material";
import dashboardApi from "Services/Dashboard";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import {
  Equalizer, Savings, NotInterested, CarRepair, Hail, SensorOccupied, SupportAgent, Link,
  Schedule, ContactPhone, PunchClock, Close
} from "@mui/icons-material";
// Date picker
import { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import moment from 'moment-timezone';
import { CUSTOM_CONSTANTS } from "Constants";
// Chart components
import TripSummaryChart from "./TripSummaryChart";
import TotalTripChart from "./TotalTripChart";

const Dashboard = () => {
  const timezone = useSelector((state) => state?.timezone?.timezone || 'America/Anchorage');
  const userid = useSelector((state) => state?.AuthReducer?.userid);
  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");
  const classes = useStyles();
  const dispatch = useDispatch();
  const [dashboardDetails, setDashboardDetails] = useState(null);
  const [startDate, setStartDate] = useState({});
  const [endDate, setEndDate] = useState({});

  // Chart data state
  const [chartData, setChartData] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState(3);

  // Get dashboard details api
  const getDashbaordDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    // console.log('Start date --->',startDate);
    // console.log('End date-->',endDate);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDashboardDetails(res?.data?.data);
      } else {
        setDashboardDetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get dashboard details Api", err);
    };
    dashboardApi.getDashboardDetails({ startDate, endDate, userid, demoaccount_id }).then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, userid, demoaccount_id, dispatch]);

  // Get chart data api
  const getChartData = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setChartData(res?.data?.data);
      } else {
        setChartData(null);
      }
    };
    const onFailure = (err) => {
      console.error("Failed to fetch chart data:", err);
      setChartData(null);
    };
    dashboardApi.getChartData({ userid, months: selectedMonths, demoaccount_id }).then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonths, userid, demoaccount_id]);

  useEffect(() => {
    getDashbaordDetails();
  }, [getDashbaordDetails, startDate, endDate]);

  useEffect(() => {
    getChartData();
  }, [getChartData]);

  const handleMonthChange = (months) => {
    setSelectedMonths(months);
  };


  const handlefromdate = (newValue) => {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    setStartDate(formattedDate);
  };

  const handletodate = (newValue) => {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    setEndDate(formattedDate);
  };

  const containerStyle = {
    display: "flex"
  };
 const roundedInputStyle = {
  width: 180, // Reduce width (change as needed)

  "& .MuiOutlinedInput-root": {
    borderRadius: "25px",
    height: "40px", // Reduce height

    "& input": {
      padding: "8px 12px", // Reduce input padding
      fontSize: "14px",    // Smaller text
    },

    "& fieldset": {
      borderColor: "#808080 !important",
    },
    "&:hover fieldset": {
      borderColor: "#808080 !important",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#808080 !important",
    },
  },

  "& .MuiInputLabel-root": {
    color: "#808080 !important",
    fontSize: "14px",
    top: "-6px",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#808080 !important",
  },

  "& .MuiSvgIcon-root": {
    fontSize: "18px", // Smaller calendar icon
  },
};

  return (
    <>
      <div style={containerStyle}>
        <div style={{ margin: "10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={roundedInputStyle}
              label="From Date"
              value={startDate}
              onChange={(newValue) => {
                handlefromdate(newValue);
              }}
              components={{
                OpenPickerIcon: () => (
                  <img
                    src="/assets/images/Dateicon.png"
                    alt="date"
                    width="20"
                    style={{ pointerEvents: "none" }}
                  />
                ),
              }}
              renderInput={(params) => <TextField sx={roundedInputStyle} {...params} />}
            />
          </LocalizationProvider>
        </div>

        <div style={{ margin: "10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={roundedInputStyle}
              label="To Date"
              value={endDate}
              onChange={(newValue) => {
                handletodate(newValue);
              }}
              components={{
                OpenPickerIcon: () => (
                  <img
                    src="/assets/images/Dateicon.png"
                    alt="date"
                    width="20"
                    style={{ pointerEvents: "none" }}
                  />
                ),
              }}
              renderInput={(params) => <TextField sx={roundedInputStyle} {...params} />}
            />
          </LocalizationProvider>
        </div>
      </div>
      <br></br>
      <br></br>

      <Grid container className={classes.root} rowSpacing={3} >
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL NO. OF RIDES</Typography>
            </div>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h5">
                  {dashboardDetails?.totalRidesCount || 0}
                </Typography>
                {/* <Equalizer/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/totalrides.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">REVENUE</Typography>
            </div>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {(dashboardDetails?.totalRevenue || 0) + " " + CUSTOM_CONSTANTS.BASE_CURRENCY}
                </Typography>
                {/* <Savings/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/revenuetotal.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>

          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL KILOMETERS DRIVEN</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {Number(dashboardDetails?.driverkilometerdriven || 0).toFixed(2)} KM
                </Typography>
                {/* <SensorOccupied/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/kmtotal.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL MINUTES SPENT</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {Number(dashboardDetails?.total_minutes || 0).toFixed(2)} Mins
                </Typography>
                {/* <PunchClock/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/totalminutes.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">TOTAL CANCELLED RIDES</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.cancelledRides || 0}
                </Typography>
                {/* <NotInterested/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/totalcancelride.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF SERVICE TYPES</Typography>
            </div>


            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.noOfServiceTypes || 0}
                </Typography>
                {/* <CarRepair/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/Noofservicetype.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">USER CANCELLED</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.userCancelledRidesCount || 0}
                </Typography>
                {/* <Hail/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/usercancelled.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>

        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">DISPATCHER CANCELLED</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.dispatcherCancelledRidesCount || 0}
                </Typography>
                {/* <SupportAgent/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/dispatchercancelled.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO.OF CARRIER</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.noOfCarrier || 0}
                </Typography>
                {/* <Link/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/Noofcarrier.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF SCHEDULED RIDES</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.scheduledRidesCount || 0}
                </Typography>
                {/* <Schedule/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/Noofscheduled.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NO. OF DISPATCHER RIDES</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.dispatcherRidesCount || 0}
                </Typography>
                {/* <ContactPhone/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/noofdispatcherride.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
        <Grid item xs={3} className={classes.container}>
          <section
            className={classes.card}
          >
            <div className={classes.nameLabel}>
              <Typography variant="h5">NOT ACCEPTED BY DRIVER</Typography>
            </div>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div className={classes.count}>
                <Typography variant="h4">
                  {dashboardDetails?.driverNotAcceptedCount || 0}
                </Typography>
                {/* <Close/> */}
              </div>
              <div className={classes.dashboardicon}>
                <img
                  src="/assets/images/Dashboardiconnew/drivernotaccepted.png"
                  alt="date"
                  width="55"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </Box>
          </section>
        </Grid>
      </Grid>

      {/* Trip Summary Chart */}
      <TripSummaryChart data={chartData?.tripSummary} />

      {/* Total Trip Chart */}
      <TotalTripChart
        data={chartData?.totalTrip}
        dailyData={chartData?.totalTripDaily}
        onMonthChange={handleMonthChange}
        selectedMonths={selectedMonths}
        charttype={"bar"}
      />
      <TotalTripChart
        data={chartData?.totalTrip}
        dailyData={chartData?.totalTripDaily}
        onMonthChange={handleMonthChange}
        selectedMonths={selectedMonths}
        charttype={"pie"}
      />
    </>
  );
};





export default Dashboard;


